import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=82b7485c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=82b7485c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b7485c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('82b7485c', component.options)
    } else {
      api.reload('82b7485c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=82b7485c&scoped=true&", function () {
      api.rerender('82b7485c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Index.vue"
export default component.exports